import React from 'react'
import styles from './CafeFirstView.module.css'
import { CafeFirstViewProps } from './types'

const IMAGES = {
    cafeFirstView: '/pages/firstview_cafe.jpg',
}

// DEV-3390のFV出し分けテストで導入し、DEV-3574でCパターン採用により恒久化した
// カフェ訴求FV。カフェクリエイティブからの流入でのみ、現行の帯FV(SlimFirstView)の
// 代わりに表示する。
// 出す条件は持たない（どの流入で出すかは呼び出し側が決める。SlimFirstViewと同じ方針。
// 条件の実体は utils/cafeFirstViewTargeting.ts）。
export const CafeFirstView = ({ dataViewLabel }: CafeFirstViewProps) => {
    return (
        <section data-view-label={dataViewLabel}>
            <div className={styles.contentWrap}>
                <img
                    src={IMAGES.cafeFirstView}
                    alt='今すぐ働けるカフェ求人見つかります！ 飲食店正社員 求人数No.1 ※'
                    width={375}
                    height={231}
                />
            </div>
        </section>
    )
}

export default CafeFirstView
